"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemTitleCell = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importStar(require("react"));
const dateUtils = __importStar(require("../../../utils/dateUtils"));
const useDebouncedState_1 = require("../../../utils/useDebouncedState");
const IconCalendar_1 = require("../../icons/IconCalendar");
const IconEdit_1 = require("../../icons/IconEdit");
const IconTime_1 = require("../../icons/IconTime");
const ResourceCalendarModal_1 = require("../../resource-calendar-modal/ResourceCalendarModal");
const AddItemDiscountAction_1 = require("../actions/AddItemDiscountAction");
const CustomizeItemAction_1 = require("../actions/CustomizeItemAction");
const DeleteItemDiscountAction_1 = require("../actions/DeleteItemDiscountAction");
const DiscountLine_1 = require("./DiscountLine");
const ItemTitleCell = (props) => {
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const [debouncedItem, setDebouncedItem] = (0, useDebouncedState_1.useDebouncedState)(props.item, (item) => {
        // Title might have changed: Make sure we're still using the matching config.
        if (!props.isResource) {
            item.updateConfigItem(props.booking);
        }
        props.onItemChange(item);
    }, 300, { leading: true });
    function handleTitleChange(value) {
        const itemClone = (0, cloneDeep_1.default)(debouncedItem);
        itemClone.title = value.slice(0, 100);
        setDebouncedItem(itemClone);
    }
    function handleDiscountChange(discount) {
        const itemClone = (0, cloneDeep_1.default)(debouncedItem);
        itemClone.discount = discount;
        setDebouncedItem(itemClone);
    }
    function handleCustomizedChange(customized) {
        const itemClone = (0, cloneDeep_1.default)(debouncedItem);
        itemClone.customized = customized;
        // Reset all fields to the item config if switched to not-customized.
        if (!customized) {
            itemClone.reset(props.booking.isFullDay());
        }
        setDebouncedItem(itemClone);
    }
    function resourceTitleElement() {
        return react_1.default.createElement("span", { className: "flex-grow-1" }, debouncedItem.title);
    }
    function resourceSubtitleElement() {
        return (react_1.default.createElement("div", { className: "d-inline-block date-and-time-btn" +
                (props.editable ? " editable" : ""), onClick: () => {
                if (props.editable) {
                    showModal(react_1.default.createElement(ResourceCalendarModal_1.ResourceCalendarModal, { booking: props.booking, onClose: hideModal, onOk: (newBooking) => {
                            props.onBookingChange(newBooking);
                            hideModal();
                        } }));
                }
            } },
            react_1.default.createElement("div", { title: "Datum und Zeit \u00E4ndern", className: "d-flex" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "small" },
                        react_1.default.createElement(IconCalendar_1.IconCalendar, null),
                        " ",
                        dateUtils.formatDate(props.booking.start),
                        " "),
                    react_1.default.createElement("div", { className: "small" },
                        react_1.default.createElement(IconTime_1.IconTime, null),
                        " ",
                        dateUtils.formatTime(props.booking.start),
                        " -",
                        " ",
                        dateUtils.formatTime(props.booking.end))),
                props.editable && (react_1.default.createElement("div", { className: "ml-2 icon-hidden icon-edit" },
                    react_1.default.createElement(IconEdit_1.IconEdit, null))))));
    }
    function addonTitleElement() {
        if (debouncedItem.customized && props.editable) {
            return (react_1.default.createElement("input", { className: "flex-grow-1", type: "text", value: debouncedItem.title, onChange: (e) => handleTitleChange(e.target.value), disabled: !props.editable }));
        }
        else {
            return react_1.default.createElement("div", { className: "flex-grow-1" }, debouncedItem.title);
        }
    }
    function titleLineElement() {
        return (react_1.default.createElement("div", { className: "d-flex" },
            props.isResource ? resourceTitleElement() : addonTitleElement(),
            !debouncedItem.discount && props.editable && (react_1.default.createElement(AddItemDiscountAction_1.AddItemDiscountAction, { item: debouncedItem, onAddDiscount: handleDiscountChange })),
            props.editable && (react_1.default.createElement(CustomizeItemAction_1.CustomizeItemAction, { booking: props.booking, item: debouncedItem, onCustomizedChange: handleCustomizedChange }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        titleLineElement(),
        props.isResource ? resourceSubtitleElement() : undefined,
        debouncedItem.discount && (react_1.default.createElement("div", { className: "discount discount-group d-flex" },
            react_1.default.createElement("span", null, "\u2517\u2501\u00A0"),
            react_1.default.createElement(DiscountLine_1.DiscountLine, { discount: debouncedItem.discount, onDiscountChange: handleDiscountChange, editable: props.editable }),
            props.editable && (react_1.default.createElement(DeleteItemDiscountAction_1.DeleteItemDiscountAction, { onDelete: () => handleDiscountChange() })))),
        modal));
};
exports.ItemTitleCell = ItemTitleCell;
